import React, { useCallback, useEffect, useRef, useState } from 'react';
import { countMyUnreadMessages } from '../../services/platformMessageService';
import MessageListModal from '../messages/MessageListModal';

/** 미읽음 카운트 폴링 간격 (ms). 2분. */
const POLL_INTERVAL_MS = 2 * 60 * 1000;

const MailIconButton: React.FC = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const fetchUnread = useCallback(async () => {
    try {
      const count = await countMyUnreadMessages();
      setUnreadCount(count);
    } catch {
      // 네트워크 오류 무시
    }
  }, []);

  useEffect(() => {
    fetchUnread();
    intervalRef.current = setInterval(fetchUnread, POLL_INTERVAL_MS);
    return () => {
      if (intervalRef.current !== null) clearInterval(intervalRef.current);
    };
  }, [fetchUnread]);

  const handleOpen = useCallback(() => setModalOpen(true), []);
  const handleClose = useCallback(() => {
    setModalOpen(false);
    // 닫힐 때 카운트 재조회
    fetchUnread();
  }, [fetchUnread]);

  const handleUnreadCountChange = useCallback((count: number) => {
    setUnreadCount(count);
  }, []);

  return (
    <>
      <button
        type="button"
        className="cp-mail-icon-btn"
        onClick={handleOpen}
        aria-label={unreadCount > 0 ? `메시지 수신함 (읽지 않은 메시지 ${unreadCount}건)` : '메시지 수신함'}
        title="메시지 수신함"
      >
        {/* 편지 봉투 SVG 아이콘 */}
        <svg
          className="cp-mail-icon-btn-svg"
          viewBox="0 0 20 20"
          fill="none"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2" y="5" width="16" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
          <path d="M2 7l8 5 8-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>

        {/* 미읽음 배지 */}
        {unreadCount > 0 && (
          <span className="cp-mail-icon-badge" aria-hidden="true">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {modalOpen && (
        <MessageListModal
          onClose={handleClose}
          onUnreadCountChange={handleUnreadCountChange}
        />
      )}
    </>
  );
};

export default MailIconButton;
